<template>
  <section class="four-blocks">
    <div class="osk-wrapper">
      <div class="four-blocks__content">
        <div
          v-for="(card, index) in cards"
          :key="index"
          class="four-blocks__card"
        >
          <UIIcon
            :name="card.image"
            class="four-blocks__image"
          />

          <div class="four-blocks__block">
            <div class="four-blocks__title">
              {{ card.title }}
            </div>
            <p class="four-blocks__text">
              {{ card.text }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import UIIcon from '~/components/ui/UIIcon.vue';

const { t } = useI18n();

const cards = [
  {
    image: 'cloth',
    title: t('components.home.old.fourBlocks.card1.title'),
    text: t('components.home.old.fourBlocks.card1.text'),
  },
  {
    image: 'guarantee',
    title: t('components.home.old.fourBlocks.card2.title'),
    text: t('components.home.old.fourBlocks.card2.text'),
  },
  {
    image: 'safe-deal2',
    title: t('components.home.old.fourBlocks.card3.title'),
    text: t('components.home.old.fourBlocks.card3.text'),
  },
  {
    image: 'delivery',
    title: t('components.home.old.fourBlocks.card4.title'),
    text: t('components.home.old.fourBlocks.card4.text'),
  },
];
</script>

<style scoped lang="scss">
.four-blocks {
  padding: 32px 0 34px;
  background: #fafafa;

  @media screen and (min-width: 1024px) {
    padding: 108px 0 51px;
  }

  &__content {
    @media screen and (min-width: 767px) {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      margin-bottom: -25px;
    }
  }

  &__card {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    & + & {
      margin-top: 24px;
    }

    @media screen and (min-width: 767px) {
      display: block;
      width: 50%;
      padding-right: 20px;
      margin-bottom: 45px;

      & + & {
        margin-top: 0;
      }
    }

    @media screen and (min-width: 1024px) {
      width: 25%;
    }
  }

  &__image {
    width: 36px;
    margin-right: 12px;
    flex-shrink: 0;
    margin-top: 4px;

    @media screen and (min-width: 767px) {
      height: 40px;
      width: auto;
      margin-top: 0;
      margin-bottom: 16px;
    }
  }

  &__title {
    font-size: 14px;
    line-height: 17px;
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;

    @media screen and (min-width: 767px) {
      font-size: 17px;
      line-height: 20px;
      margin-bottom: 12px;
    }
  }

  &__text {
    font-size: 12px;
    line-height: 18px;
    color: #828282;

    @media screen and (min-width: 767px) {
      font-size: 13px;
      padding-right: 20px;
    }
  }
}
</style>
